import { useCallback, useEffect, useRef, useState } from "react";

/** README: 画面下中央のトースト。3.2秒で消える（useToast は2.6秒固定なので Amazon 画面用に別実装）。 */
export function useAmzToast() {
  const [message, setMessage] = useState("");
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (timer.current) clearTimeout(timer.current);
    };
  }, []);

  const showToast = useCallback((msg: string) => {
    if (timer.current) clearTimeout(timer.current);
    setMessage(msg);
    timer.current = setTimeout(() => setMessage(""), 3200);
  }, []);

  return { toastMessage: message, showToast };
}
